import { debounce } from '../../../../cms-global-components/_Helpers/utils';

let currentBreakpoint = null;

const addVideoEventListeners = ($videoElement, videoWrapper) => {
  $videoElement.onplaying = () => {
    videoWrapper.setAttribute('data-video-state', 'playing');
  };
  $videoElement.onpause = () => {
    videoWrapper.setAttribute('data-video-state', 'paused');
  };
  $videoElement.onended = () => {
    videoWrapper.setAttribute('data-video-state', 'ended');
  };
};

export { addVideoEventListeners };

export const loadVideoPlayer = (videoWrapper, desktopVideoUrl, tabletVideoUrl, mobileVideoUrl) => {
  if (!(videoWrapper instanceof HTMLElement)) {
    console.error('videoWrapper is not a valid HTML element', videoWrapper);
    return;
  }

  const $videoElement = videoWrapper.querySelector('video');
  if (!$videoElement) {
    console.error('No video element found within videoWrapper', videoWrapper);
    return;
  }

  let currentBreakpoint = '';

  const load = () => {
    const isDesktop = window.matchMedia("(min-width: 1200px)").matches;
    const isTablet = window.matchMedia("(min-width: 768px) and (max-width: 1199px)").matches;

    const newBreakpoint = isDesktop ? 'desktop' : isTablet ? 'tablet' : 'mobile';

    if (newBreakpoint !== currentBreakpoint) {
      let videoUrl;

      if (isDesktop) {
        videoUrl = desktopVideoUrl;
      } else if (isTablet) {
        videoUrl = tabletVideoUrl;
      } else {
        videoUrl = mobileVideoUrl;
      }

      $videoElement.src = videoUrl;

      if (typeof $videoElement.load === 'function') {
        $videoElement.load();
        addVideoEventListeners($videoElement, videoWrapper);
      }
      currentBreakpoint = newBreakpoint;
    }
  };

  load();
  const debouncedLoad = debounce(load, 200);
  window.addEventListener('resize', debouncedLoad);

  return () => {
    window.removeEventListener('resize', debouncedLoad);
  };
};
